// extracted by mini-css-extract-plugin
export var adjacentSlide = "_jv-9";
export var arrowButtonContainer = "_jv-5";
export var arrowButtonIcon = "_jv-6";
export var carouselArrowButton = "_jv-2";
export var carouselElementContainer = "_jv-1";
export var currentSlide = "_jv-8";
export var left = "_jv-3";
export var otherSlide = "_jv-a";
export var productCarouselContainer = "_jv-0";
export var right = "_jv-4";
export var sliderOverflow = "_jv-7";